import axios from 'utils/axios';
import { put, select } from 'redux-saga/effects';
import * as HitFactorCollections from 'actions/HitFactorCollections';
import { toastr } from 'react-redux-toastr'
import i18n from 'i18n/i18n.js';
import { arrayMove } from 'utils/helpers';

export function* onCreateCollectionRequest({ payload: body, cb }) {
  try {

    const data = new FormData();

    // Create inspiration collection form
    data.append('inspirationCollectionTitle', body.inspirationCollectionTitle);
    data.append('inspirationCollectionCaption', body.inspirationCollectionCaption);
    data.append('inspirationCaption', body.inspirationCaption);	
    data.append('file', body.fileUrl);

    const { data: rs } = yield axios.post(`/api/company/createInspirationCollection`, data);
    
    if (rs && rs.data && rs.data.status === "INTERNAL_SERVER_ERROR") {
      throw Error(rs.data.message);
    }
    
    yield put(HitFactorCollections.onCreateCollectionSuccess(rs))
    // yield call(onGetRequest, { cb });
  
    } catch (e) {
        yield put(HitFactorCollections.onCreateCollectionFailure({ message: e.toString() }));
        cb && cb(e);
    }
}

export function* onUpdateCollectionRequest({ payload: body, cb }) {
  try {

    const data = new FormData();

    // Create inspiration collection form
    data.append('inspirationCollectionId', body.inspirationCollectionId);
    data.append('title', body.title);
    data.append('caption', body.caption);
    data.append('file', body.file);

    const { data: rs } = yield axios.post(`/api/company/updateInspirationCollection`, data);
    
    if (rs && rs.data && rs.data.status === "INTERNAL_SERVER_ERROR") {
      throw Error(rs.data.message);
    }
    
    yield put(HitFactorCollections.onUpdateCollectionSuccess(rs))
    // yield call(onGetRequest, { cb });
  
    } catch (e) {
        yield put(HitFactorCollections.onUpdateCollectionFailure({ message: e.toString() }));
        cb && cb(e);
    }
}

export function* onCreateCollectionImageRequest({ payload: body, cb }) {
  try {

    const data = new FormData();

    // Create inspiration collection form
    data.append('collectionId', body.collectionId);
    data.append('caption', body.caption);	
    data.append('file', body.file);

    const { data: rs } = yield axios.post(`/api/student/addInspiration`, data);
    
    if (rs && rs.data && rs.data.status === "INTERNAL_SERVER_ERROR") {
      throw Error(rs.data.message);
    }
    
    yield put(HitFactorCollections.onCreateCollectionImageSuccess(rs))
    // yield call(onGetRequest, { cb });
  
    } catch (e) {
        yield put(HitFactorCollections.onCreateCollectionImageFailure({ message: e.toString() }));
        cb && cb(e);
    }
}

export function* onUpdateCollectionImageRequest({ payload, cb }) {
  try {

    const data = {
      "inspirationId" : payload.inspirationId,
      "caption" : payload.caption
  }

    const { data: rs } = yield axios.post(`/api/student/setInspirationCaption`, data);
    
    if (rs && rs.data && rs.data.status === "INTERNAL_SERVER_ERROR") {
      throw Error(rs.data.message);
    }
    
    yield put(HitFactorCollections.onUpdateCollectionImageSuccess(payload))
    // yield call(onGetRequest, { cb });
  
    } catch (e) {
        yield put(HitFactorCollections.onUpdateCollectionImageFailure({ message: e.toString() }));
        cb && cb(e);
    }
}

export function* onDeleteCollectionRequest({ payload, cb }) {
    try {
  
      yield axios.delete(`/api/student/deleteInspirationCollection`, { data: payload });
  
      yield put(HitFactorCollections.onDeleteCollectionSuccess(payload));
  
      toastr.success(i18n.t('toastr.onDeleteCollectionSuccess.title'), i18n.t('toastr.onDeleteCollectionSuccess.body'))

      cb && cb(null);
    } catch (e) {
      yield put(HitFactorCollections.onDeleteCollectionFailure({ message: e.toString() }));
      cb && cb(e);
    }
  }

export function* onDeleteImageRequest({ payload: body, cb }) {
  try {
    if (!body.collectionId) {
      throw new Error('Collection id is empty');
    }

    if (!body.inspirationId) {
      throw new Error('Inspiration id is empty');
    }

    const { data: rs } = yield axios.post(`/api/student/deleteInspiration/${body.collectionId}`, {
      inspirationId: body.inspirationId
    });

    yield put(HitFactorCollections.onDeleteImageSuccess(body));
    cb && cb(rs);
  } catch (e) {
    yield put(HitFactorCollections.onDeleteImageFailure({ message: e.toString() }));
    cb && cb(e);
  }
}

export function* onMoveImageImageRequest({ payload, cb }) {

  const inspirationCollections = yield select((state) => state.company.companyProfile.inspirationCollections);
  const inspirationCollection = inspirationCollections && inspirationCollections.filter(collection => collection.inspirationCollectionId == payload.collectionId)[0];
  let imageOrder = inspirationCollection.inspirations;

  let body = imageOrder.map((object, index) => {
    return(
        {
          "inspirationId" : object.inspirationId,
          "position" : index
        }
    );
  })

  try {  
    const { data: rs } = yield axios.post(`/api/inspiration/setPosition`, body);

    // yield put(HitFactorCollections.onDeleteImageSuccess(body));
    cb && cb(rs);
  } catch (e) {
    // yield put(HitFactorCollections.onDeleteImageFailure({ message: e.toString() }));
    cb && cb(e);
  }
}

export function* onMoveCollectionRequest({ payload, cb }) {

  const inspirationCollections = yield select((state) => state.company.companyProfile.inspirationCollections);

  let body = inspirationCollections.map((object, index) => {
    return(
        {
          "inspirationCollectionId" : object.inspirationCollectionId,
          "position" : index
        }
    );
  })

  try {  
    const { data: rs } = yield axios.post(`/api/inspirationCollection/setPosition`, body);
    cb && cb(rs);
  } catch (e) {
    cb && cb(e);
  }
}